import { createApiActionType, createActionType } from 'app/store/utils';

const apiType = createApiActionType('snowflakeQueries');
const type = createActionType('snowflakeQueries');

export const SUBMIT_QUERY = apiType('SubmitQuery');
export const GET_QUERY_STATUS = apiType('GetQueryStatus');
export const GET_QUERY_RESULTSET = apiType('GetQueryResultset');
export const CANCEL_QUERY = apiType('CancelQuery');
export const CANCEL_ALL_QUERIES = apiType('CancelAllQueries');
export const LOOKUP_AND_CANCEL_QUERY = type('LookupAndCancelQuery');

export const DELETE_DATASET_QUERY = type('DeleteDatasetQuery');
export const DELETE_JOIN_QUERIES = type('DeleteJoinQueries');
export const DELETE_EXPLORE_QUERY = type('DeleteExploreQuery');
export const DELETE_FQN_QUERY = type('DeleteFQNQuery');
export const DELETE_ROW_COUNT_QUERY = type('DeleteRowCountQuery');
export const DELETE_EXTRACT_JSON_QUERIES = type('DeleteExtractJsonQueries');
export const DELETE_FILTERED_METRICS_QUERIES = type('DeleteFilteredMetricsQueries');
export const DELETE_QUERY = type('DeleteQuery');

export const INVALIDATE_FQN_QUERY = type('InvalidateFQNQuery');
export const INVALIDATE_EXPLORE_QUERIES = type('InvalidateExploreQueries');

export const ENSURE_DATASET_LOADED = type('EnsureDatasetLoaded');

export const EXECUTE_DATASET_QUERY = apiType('ExecuteDatasetQuery');
export const EXECUTE_SQL_QUERY = apiType('ExecuteSqlQuery');
export const EXECUTE_TRANSFORMATION_QUERY = apiType('ExecuteTransformationQuery');
export const EXECUTE_EXPLORE_QUERY = apiType('ExecuteExploreQuery');
export const EXECUTE_FQN_QUERY = apiType('ExecuteFQNQuery');
export const EXECUTE_ROW_COUNT_QUERY = apiType('ExecuteRowCountQuery');
export const EXECUTE_COLUMN_MANAGEMENT_PREVIEW_QUERY = apiType(
    'ExecuteColumnManagementPreviewQuery'
);

export const CLEANUP_AND_INVALIDATE_QUERIES = type('CleanupAndInvalidateQueries');
export const CANCEL_AND_DELETE_EXPLORE_QUERIES = type('CancelAndDeleteExploreQueries');

export const LIST_QUERIES = type('ListQueries');
export const RESUME_QUERY = type('ResumeQuery');
export const RESTORE_QUERY = type('RestoreQuery');

export const DELETE_MULTIJOIN_VALIDATION_QUERIES = type('DeleteMultiJoinValidationQueries');
